import React, { useEffect, useState } from 'react';
import Switch from 'rc-switch';
import Numeral from 'numeral';
import Dropdown, { placeholder_default_value } from '../components/Dropdown';
import TextInput from '../components/TextInput';
import SectionHeader from '../components/SectionHeader';
import CheckboxGroup from '../components/CheckboxGroup';
import {fetchSellTypes, getBrandsList, getCategoriesList} from '../services/filter';

const VehicleAdFilters = (props) => {

    const defaultStates = {
        term: '',
        category: placeholder_default_value,
        brand: placeholder_default_value,
        fromYear: placeholder_default_value,
        toYear: placeholder_default_value,
        fromMileage: '',
        toMileage: '',
        fromPrice: '',
        toPrice: '',
        visualised: false,
        seller: placeholder_default_value,
        orderby: placeholder_default_value,
        type: placeholder_default_value,
    }

    const sellers = [{
        id: 'agency',
        name: 'نمایندگی'
    },{
        id: 'autogallery',
        name: 'نمایشگاه'
    }]
    
    const orders = [{
        id: 'recent',
        name: 'اخیرا'
    },{
        id: 'expensive',
        name: 'گرون ترین'
    },{
        id: 'cheaper',
        name: 'ارزان ترین'
    },{
        id: 'mileage',
        name: 'کم کارکرد ترین'
    },{
        id: 'older',
        name: 'قدیمی ترین'
    },{
        id: 'newer',
        name: 'جدیدترین'
    },]

    const [sellTypes, setSellTypes] = useState([])
    const [categories, setCategories] = useState([])
    const [brands, setBrands] = useState([])
    const [constructionYears, setConstructionYears] = useState([])
    const [states, setStates] = useState(defaultStates)

    useEffect(()=> {
        fetchSellTypes()
        .then((response) => {
            setSellTypes(response.data)
        })
        .catch((error) => {
        })
    }, [])

    useEffect(()=> {
        getCategoriesList()
        .then((response) => {
            setCategories(response.data)
        })
        .catch((error) => {
        })
    }, [])

    useEffect(()=> {
        const brandsFilter = states.category === placeholder_default_value ? {} : {parameter:{category:states.category}}
        getBrandsList(brandsFilter)
        .then((response) => {
            setBrands(response.data)
            setStates({...states, brand: placeholder_default_value})
        })
        .catch((error) => {
        })
    }, [states.category])

    useEffect(() => {
        if (constructionYears.length === 0){
            const tempYears = []
            for (let index = 1365; index < (new Date().getFullYear() - 620); index++) {
                tempYears.push({id: index, name: `${index} - ${index + 620}`})
            }
            setConstructionYears(tempYears)
        }
    }, [])

    const onDropdownChanged = (field, e) => {
        setStates({ ...states, [field]: e.target.value })
    }

    const onTextChanged = (field, type='text', e) => {
        if (type === 'number') {
            const val = e.target.value.replace(/,/g, "");
            if (val.match(/^[0-9]*$/)){
                setStates({ ...states, [field]: val })
            }
        }
        else {
            setStates({ ...states, [field]: e.target.value })
        }
    }

    const onPicturedOnlyChanged = (isChecked) => {
        setStates({ ...states, 'visualised': isChecked })
    }

    const onClearFilters = () => {
        setStates(defaultStates)
    }

    const onSubmitFilters = () => { 
        const cleanedKeys = Object.keys(states).filter(key => states[key] !== false && states[key] !== '' && states[key] !== placeholder_default_value )
        const cleanedFilters = cleanedKeys.map(key => `${key}=${states[key]}`).join('&');
        props.history.push(`/vehicles/?${cleanedFilters}`)
    }

    return (
        <div className='filter-container'>
            <div className='filter-content-container'>
                <TextInput classes="col-12" hasError={false} placeholder="دنبال چی می‌گردی؟" type='text' onChange={onTextChanged.bind(this, 'term', 'text')} value={states['term']} />
                <Dropdown classes="col-6" hasError={false} placeholder="انتخاب کاربری" options={categories} onChange={onDropdownChanged.bind(this, 'category')} value={states['category']} />
                <Dropdown classes="col-6" hasError={false} placeholder="انتخاب برند" options={brands} onChange={onDropdownChanged.bind(this, 'brand')} value={states['brand']} />
                <SectionHeader classes='col-12 px-0 py-2' title={'سال تولید'} />
                <Dropdown classes="col-6" hasError={false} placeholder="از سال" options={constructionYears} onChange={onDropdownChanged.bind(this, 'fromYear')} value={states['fromYear']} />
                <Dropdown classes="col-6" hasError={false} placeholder="تا سال" options={constructionYears} onChange={onDropdownChanged.bind(this, 'toYear')} value={states['toYear']} />
                <SectionHeader classes='col-12 px-0 py-2' title={'کارکرد ماشین'} />
                <TextInput classes="col-6" hasError={false} placeholder="از کارکرد" type='text' onChange={onTextChanged.bind(this, 'fromMileage', 'number')} value={states['fromMileage'] === "" ? "" :Numeral(states['fromMileage']).format('0,0')} />
                <TextInput classes="col-6" hasError={false} placeholder="تا کارکرد" type='text' onChange={onTextChanged.bind(this, 'toMileage', 'number')} value={states['toMileage'] === "" ? "" :Numeral(states['toMileage']).format('0,0')} />
                <SectionHeader classes='col-12 px-0 py-2' title={'بازه قیمت (تومان)'} />
                <TextInput classes="col-6" hasError={false} placeholder="از قیمت" type='text' onChange={onTextChanged.bind(this, 'fromPrice', 'number')} value={states['fromPrice'] === "" ? "" :Numeral(states['fromPrice']).format('0,0')} />
                <TextInput classes="col-6" hasError={false} placeholder="تا قیمت" type='text' onChange={onTextChanged.bind(this, 'toPrice', 'number')} value={states['toPrice'] === "" ? "" :Numeral(states['toPrice']).format('0,0')} />
                <SectionHeader classes='col-12 px-0 py-2' title={'نوع فروش'} />
                <CheckboxGroup classes="col-12" hasError={false} options={sellTypes} onChange={onDropdownChanged.bind(this, 'type')} value={states['type']} />
                <div className='image-filter-container col-12 px-1 py-3'>
                    <span>فقط آگهی‌های عکس‌دار</span>
                    <Switch
                        className="custom-switch custom-switch-primary"
                        checked={states['visualised']}
                        onChange={onPicturedOnlyChanged}
                    />
                </div>
                <SectionHeader classes='col-12 px-0 py-2' title={'ترتیب نمایش'} />
                <Dropdown classes="col-6" hasError={false} placeholder="نوع فروشنده" options={sellers} onChange={onDropdownChanged.bind(this, 'seller')} value={states['seller']} />
                <Dropdown classes="col-6" hasError={false} placeholder="به ترتیب" options={orders} onChange={onDropdownChanged.bind(this, 'orderby')} value={states['orderby']} />
            </div>
            <div className='filter-actions-container px-0'>
                <div onClick={onClearFilters} className='clear-btn--search col-3 px-0'>
                    <span>حذف فیلتر‌ها</span>
                </div>
                <div onClick={onSubmitFilters} className='home-btn--search col-9 px-0'>
                    <span>اعمال کردن فیلتر‌ها</span>
                </div>
            </div>
        </div>
    );
}

export default VehicleAdFilters;